import React, { useEffect, useRef, useState } from "react";
import CommonInput from "../../../CommonMethhods/CommonInput";
import { Lead_Creation } from "../../../Configuration/API_URL";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
  validateIFSC,
} from "../../../CommonMethhods/CommonMethods";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, useWatch } from "react-hook-form";
import CommonSelect from "../../../CommonMethhods/CommonSelect";
import { Modal } from "react-bootstrap";
import { useResumeContext } from "../../../CommonMethhods/Context";
import { useClientContext } from "../../../context/ClientContext";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function BankDetails(props) {
  const IndiMobileNo = localStorage.getItem("IndiMobileNo");
  const storeToken = localStorage.getItem("ssoToken");
  const resumeVal = props?.resumeVal;
  const masterValue = props?.masterValue;
  const [bankVeriModal, setBankVeriModal] = useState(false);
  const [bankVerified, setBankVerified] = useState(false);
  const { resumeHandle } = useResumeContext();
  const [isDetailsSaved, setIsDetailsSaved] = useState(false);
  const activeTab = props?.activeTab;
  const { selectedClient, shouldPrefill } = useClientContext();

  const errorSchema = Yup.object().shape({
    bankAcNoValid: Yup.string().required("Bank Account Number is required").min(9, "Please enter a bank account number between 9 and 18 digits."),
    confBankAcNoValid: Yup.string().required("Confirm Bank Account Number").min(9, "Please enter a bank account number between 9 and 18 digits.")
      .oneOf([Yup.ref("bankAcNoValid")], "Bank account numbers should be same"),
    ifscCodeValid: Yup.string().required("IFSC Code is required")
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Enter valid IFSC Code"),
    acTypeValid: Yup.string().required("Account type is required"),
    gstRegisteredValid: Yup.string().required("Select GST registered or not"),
    gstNumberValid: Yup.string().when("gstRegisteredValid", {
      is: "Yes",
      then: (schema) =>
        schema
          .required("GST Number is required")
          .matches(
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
            // /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[A-Z0-9]{1}$/,
            "Enter Valid GST Number"
          )
          .length(15, "GST Number must be exactly 15 characters"),
      otherwise: (schema) => schema.notRequired(),
    }),
    isGSTDocCollectedValid: Yup.string().when("gstRegisteredValid", {
      is: "Yes",
      then: (schema) => schema.required("Select GST document is collected or not"),
      otherwise: (schema) => schema.notRequired(),
    }),

    isChequeCollected: Yup.string().when([], {
      is: (_, schemaContext) => schemaContext?.bankVerified === true,
      then: (schema) => schema.required("Select Cancelled cheque is collected or not"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    getValues,
    reset: resetForm,
    trigger,
    setValue,
    formState: { errors, isDirty, isValid },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(errorSchema),
    context: { bankVerified }
  });

  const gstRegistered = watch("gstRegisteredValid");
  const cheque = watch("isChequeCollected");
  const bank = useWatch({ control, name: "bankAcNoValid" });

  const checkImpsVerified = async (data) => {

    let payloadValue = {
      mobileNo: IndiMobileNo || resumeVal?.verificationDetails?.mobileNo,
      acNo: data?.bankAcNoValid,
      ifsc: data?.ifscCodeValid,
    };

    console.log(payloadValue, "payloadValue");
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRelation = await axiosInstance.post(
        Lead_Creation.imps_verification,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getRelation?.data);
      console.log(res, "resimps");

      if (res?.status === 0) {
        resumeHandle(); 
      } else {
        setBankVeriModal(true);
        // toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const insertBankDetails = async (data) => {
    console.log(data?.isChequeCollected, bankVerified, "data");

    let payloadValue = {
      refId: resumeVal?.id,
      mobileNo: IndiMobileNo || resumeVal?.verificationDetails?.mobileNo,
      bankAcNo: data?.bankAcNoValid,
      confirmBankAcNo: data?.confBankAcNoValid,
      bankName: data?.bankNameValid,
      bankBranch: data?.bankBranchValid,
      ifscCode: data?.ifscCodeValid,
      acType: data?.acTypeValid,
      gstRegistered: data?.gstRegisteredValid === "Yes" ? true : false,
      gstNo: data?.gstRegisteredValid === "Yes" ? data?.gstNumberValid : "",
      isGSTDocCollected: data?.gstRegisteredValid === "Yes" && data?.isGSTDocCollectedValid === "Yes" ? true : false,
      isCancelledChequeCollected: data?.isChequeCollected === "Yes" ? true : bankVerified === true ? true : false,
    };

    console.log(payloadValue, "payloadValue");
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRelation = await axiosInstance.post(
        Lead_Creation.bank_Details,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getRelation?.data);
      if (res?.status === 0) {
        if (data?.isChequeCollected !== "Yes" || bankVerified !== true) {
          checkImpsVerified(data);
        }
        if (bankVerified === true) {
          resumeHandle();
        }
        toast.success(res?.data);
        setIsDetailsSaved(true);

      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   trigger("confBankAcNoValid");
  // }, [bank, trigger]);

  const finalSubmit = (data) => {
    console.log(data, "finalSubmit");
    if (IndiMobileNo !== null || resumeVal?.verificationDetails?.mobileNo !== "") {
      insertBankDetails(data)
    }
  };

  useEffect(() => {
    if (activeTab !== "individual") {
      resetForm({
        bankAcNoValid: "",
        confBankAcNoValid: "",
        ifscCodeValid: "",
         acTypeValid: "",
        gstRegisteredValid: "",
        gstNumberValid: "",
        isGSTDocCollectedValid: "",
        isChequeCollected: "",
        bankNameValid: "",
        bankBranchValid: "",
      });
    } else if (
      shouldPrefill &&
      selectedClient?.mobile &&
      resumeVal?.BankDetails
    ) {
      resetForm({
        bankAcNoValid: resumeVal.BankDetails.bankAcNo || "",
        confBankAcNoValid: resumeVal.BankDetails.bankAcNo || "",
        ifscCodeValid: resumeVal.BankDetails.ifsccode || "",
        acTypeValid: resumeVal.BankDetails.acType || "",
        gstRegisteredValid:
          resumeVal.BankDetails.gstRegistered === false ? "No" : "Yes",
        gstNumberValid: resumeVal.BankDetails.gstDoc || "",
        isGSTDocCollectedValid:
          resumeVal.BankDetails.gstRegistered === true ? "Yes" : "No",
        isChequeCollected:
          resumeVal.BankDetails.isCancelledChequeCollected === true
            ? "Yes"
            : "No",
        bankNameValid: resumeVal.BankDetails.bankName || "",
        bankBranchValid: resumeVal.BankDetails.bankBranch || "",
      });
      if(resumeVal?.BankDetails?.isCancelledChequeCollected){
        setBankVerified(true)
      }
    }
  }, [
    activeTab,
    shouldPrefill,
    selectedClient?.mobile,
    resumeVal,
  ]);

  console.log(resumeVal?.BankDetails, bankVerified, "resumeVal");


  const defaultOptions = [
    { label: "Yes", name: "Yes" },
    { label: "No", name: "No" },
  ];

  const accountOptions = [
    { label: "Saving", name: "Saving" },
    { label: "Current", name: "Current" },
  ];

  const handleProceedBtn = () => {
    setBankVerified(true)
    setBankVeriModal(false);

  };

  useEffect(() => {
    const subscription = watch(() => {
      setIsDetailsSaved(false);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onHide = () => {
    setBankVeriModal(false);
    setBankVerified(true)
  }

  useEffect(() => {
    if (gstRegistered === "No") {
      setValue("gstNumberValid", "", { shouldValidate: true });
      setValue("isGSTDocCollectedValid", "", { shouldValidate: true });
    }
  }, [gstRegistered, setValue]);

  const handleBankNum = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text");
    const digitsOnly = pasteData.replace(/\D/g, "").slice(0, 18);

    if (digitsOnly.length > 0) {
      const fieldName = e.target.name;
      setValue(fieldName, digitsOnly, { shouldValidate: true });
      if (fieldName === "confBankAcNoValid") {
        const originalValue = getValues("bankAcNoValid");
        if (originalValue && digitsOnly !== originalValue) {
          setError("confBankAcNoValid", {
            type: "manual",
            message: "Bank account numbers must match",
          });
        } else {
          clearErrors("confBankAcNoValid");
        }
        trigger("confBankAcNoValid");
      }
      if (fieldName === "bankAcNoValid") {
        trigger("bankAcNoValid");
      }
    }
  };

  const enterBankNum = (e) => {
    const field = e.target.name;
    const value = e.target.value.replace(/\D/g, "").slice(0, 18);

    setValue(field, value, { shouldValidate: true, shouldDirty: true });

    // If main account changed, revalidate confirm
    if (field === "bankAcNoValid") {
      trigger("confBankAcNoValid");
    }
  };

  const handlePasteIFSC = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData
      .getData("text")
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "")
      .slice(0, 11);

    const ifscPattern = /^[A-Z]{4}0[A-Z0-9]{6}$/;

    if (ifscPattern.test(pastedText)) {
      setValue("ifscCodeValid", pastedText, { shouldValidate: true });
      clearErrors("ifscCodeValid");
      trigger("ifscCodeValid");
    } else {
      setError("ifscCodeValid", {
        type: "manual",
        message: "IFSC Code is required",
      });
    }
  };

  const handleGstNumPaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text");
    const cleaned = pasteData
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 15); // ✅ max 15 chars

    if (cleaned.length > 0) {
      const input = e.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const currentValue = input.value;

      const newValue =
        currentValue.substring(0, start) + cleaned + currentValue.substring(end);

      const finalValue = newValue.slice(0, 15); // ✅ restrict to 15
      input.value = finalValue;
      setValue("gstNumberValid", finalValue, {
        shouldValidate: true,
        shouldDirty: true,
      });
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }
  };

  useEffect(() => {
  if (bankVerified) {
    setValue("isChequeCollected", "Yes");
  } else{
    setValue("isChequeCollected", "");
  }
}, [bankVerified, setValue]);

useEffect(()=>{
  if(gstRegistered === "Yes"){
    setValue("isGSTDocCollectedValid", "Yes")
  }else{
setValue("isGSTDocCollectedValid", "")
  }
}, [gstRegistered])


  return (
    <>
      <div className="row border-parent accordian-section-wrapper">
        <form className="individual-form nominee-form" onSubmit={handleSubmit(finalSubmit)}>
          <>
            <div className="row border-parent accordian-section-wrapper">
              <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
                <CommonInput
                  label="Bank Account Number"
                  name="bankAcNoValid"
                  placeholder="Enter bank account number"
                  required
                  max={18}
                  min={9}
                  register={register}
                  pattern="[0-9]*"
                  onPaste={handleBankNum}
                  value={resumeVal?.BankDetails?.bankAcNo}
                  onInput={enterBankNum}
                />
                <p className="forget-link add-error">
                  <span>
                    {errors?.bankAcNoValid?.message}
                  </span>
                </p>
              </div>

              <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
                <CommonInput
                  type="password"
                  label="Confirm Bank Account Number"
                  name="confBankAcNoValid"
                  placeholder="Re-enter bank account number"
                  required
                  pattern="[0-9]*"
                  max={18}
                  min={9}
                  register={register}
                  onPaste={handleBankNum}
                  onInput={enterBankNum}
                  id="confirmBankPass"
                  value={resumeVal?.BankDetails?.bankAcNo}
                />

                <p className="forget-link add-error">
                  <span>
                    {errors?.confBankAcNoValid?.message}
                  </span>
                </p>
              </div>

              <div className="col-sm-6 col-lg-3 card-accordian lead-creation">
                {/* <CommonInput
                label="IFSC Code"
                name="ifscCodeValid"
                placeholder="Enter IFSC code"
                required
                max={11}
                register={register}
                // onInput={handleIFSCInput}
                onKeyDown={handleIFSCKeyDown}
                onPaste={handlePasteIFSC}
                value={resumeVal?.BankDetails?.ifsccode}  
              /> */}

                <CommonInput
                  label="IFSC Code"
                  name="ifscCodeValid"
                  placeholder="Enter IFSC code"
                  required
                  register={register}
                  onKeyPress={validateIFSC}
                  // onInput={IFSCToUpper}     
                  maxLength={11}
                  onPaste={handlePasteIFSC}
                  onChange={(e) => {
                    const start = e.target.selectionStart;
                    const end = e.target.selectionEnd;

                    let input = e.target.value;
                    input = input
                      .toUpperCase()
                      .replace(/[^A-Z0-9]/g, "")
                      .replace(/\s+/g, " ")
                      // .trimStart()
                      .slice(0, 11);

                    e.target.value = input;

                    e.target.setSelectionRange(start, end);
                  }}

                  value={resumeVal?.BankDetails?.ifsccode}
                />
                <p className="forget-link add-error">
                  <span>{errors?.ifscCodeValid?.message}</span>
                </p>
              </div>

              <div className="col-sm-6 col-lg-3 card-accordian lead-creation individiual-select">
                <CommonSelect
                  label="Account Type"
                  name="acTypeValid"
                  options={accountOptions}
                  required
                  register={register}
                  value={getValues("acTypeValid")}
                />
                <p className="forget-link add-error">
                  <span>{errors?.acTypeValid?.message}</span>
                </p>
              </div>

              <div className="col-sm-6 col-lg-3 card-accordian lead-creation individiual-select">
                <CommonSelect
                  label="GST Registered"
                  name="gstRegisteredValid"
                  options={defaultOptions}
                  required
                  register={register}
                  value={getValues("gstRegisteredValid")}
                />
                <p className="forget-link add-error">
                  <span>{errors?.gstRegisteredValid?.message}</span>
                </p>
              </div>

              {gstRegistered === "Yes" && (
                <>
                  <div className="col-sm-6 col-lg-3 card-accordian lead-creation">

                    <CommonInput
                      label="GST Number"
                      name="gstNumberValid"
                      placeholder="Enter GST Number"
                      required
                      maxLength={15}
                      register={register}
                      onKeyDown={(e) => {
                        const { value, selectionStart } = e.target;
                        const pos = selectionStart; // current typing position
                        const key = e.key;

                        if (e.ctrlKey || e.metaKey) { return; }
                        if (
                          ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(key)
                        ) {
                          return;
                        }

                        const k = key.toUpperCase();

                        if (pos < 2) {
                          if (!/[0-9]/.test(key)) {
                            e.preventDefault();
                          }
                        }
                        else if (pos >= 2 && pos < 7) {
                          if (!/[A-Z]/.test(k)) {
                            e.preventDefault();
                          }
                        }
                        else if (pos >= 7 && pos < 11) {
                          if (!/[0-9]/.test(key)) {
                            e.preventDefault();
                          }
                        }
                        else if (pos === 11) {
                          if (!/[A-Z]/.test(k)) {
                            e.preventDefault();
                          }
                        }
                        else if (pos === 12) {
                          if (!/[A-Z1-9]/.test(k)) {
                            e.preventDefault();
                          }
                        }
                        else if (pos === 13) {
                          if (k !== "Z") {
                            e.preventDefault();
                          }
                        }
                        else if (pos === 14) {
                          if (!/[A-Z0-9]/.test(k)) {
                            e.preventDefault();
                          }
                        }
                        else if (pos >= 15) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        const { selectionStart, selectionEnd, value } = e.target;

                        let input = value
                          .toUpperCase()
                          .replace(/[^A-Z0-9]/g, "")
                          .slice(0, 15);

                        e.target.value = input;

                        e.target.setSelectionRange(selectionStart, selectionEnd);

                        // Update the value in the form state
                        setValue("gstNumberValid", input, {
                          shouldValidate: true,
                          shouldDirty: true,
                        });
                      }}

                      onPaste={(e) => {
                        e.preventDefault();
                        const pasteData = e.clipboardData.getData("text").toUpperCase().trim();

                        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/;

                        if (gstRegex.test(pasteData)) {
                          e.target.value = pasteData;
                          setValue("gstNumberValid", pasteData, {
                            shouldValidate: true,
                            shouldDirty: true,
                          });
                        } else {
                          e.target.value = "";
                          setValue("gstNumberValid", "", {
                            shouldValidate: true,
                            shouldDirty: true,
                          });
                        }
                      }}
                    />
                    <p className="forget-link add-error">
                      <span>{errors?.gstNumberValid?.message}</span>
                    </p>
                  </div>
                  <div className="col-sm-6 col-lg-3 card-accordian lead-creation individiual-select">
                    <CommonSelect
                      label="GST Document Collected"
                      name="isGSTDocCollectedValid"
                      options={defaultOptions}
                      required
                      register={register}
                      value={getValues("isGSTDocCollectedValid")}
                      getValues={getValues("isGSTDocCollectedValid") === "Yes"}
                      disable={getValues("isGSTDocCollectedValid") === "Yes"}
                    />
                    <span className="gray-text" style={{ color: "#9E9E9E" }}>
                      Please collect GST document for verification
                    </span>
                    <p className="forget-link add-error">
                      <span>{errors?.isGSTDocCollectedValid?.message}</span>
                    </p>
                  </div>
                </>
              )}

              {(bankVerified === true || resumeVal?.BankDetails?.isCancelledChequeCollected === true) &&
                <div className="col-sm-6 col-lg-3 card-accordian lead-creation individiual-select">
                  <CommonSelect
                    label="Cancelled Cheque Collected"
                    name="isChequeCollected"
                    options={defaultOptions}
                    required
                    register={register}
                    value={getValues("isChequeCollected")}
                    getValues={bankVerified}
                    disable={bankVerified}
                  />
                  <span className="gray-text" style={{ color: "#9E9E9E" }}>
                    Please collect cancelled cheque for verification
                  </span>
                  <p className="forget-link add-error">
                    <span>{errors?.isChequeCollected?.message}</span>
                  </p>
                </div>
              }
            </div>
            {console.log(bankVerified, resumeVal?.BankDetails, "isDetailsSaved")
            }

            <div className="wrap-button">
              <button type="submit"
              className="val-btn-wrap"
                // className={`val-btn-wrap ${(bankVerified === true && cheque === "No") ||
                //   !isDirty || !isValid || isDetailsSaved ? "val-btn-wrap disable-btn" : ""}`}
                // disabled={
                //   (bankVerified === true && cheque === "No")
                //   ||
                //   !isDirty || !isValid || isDetailsSaved
                // }
              >
                Save
              </button>
            </div>
          </>
        </form>
      </div>

      <Modal
        show={bankVeriModal}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model ifsc-Modal bank-verify-modal individual-modal"
        backdrop="static"
        keyboard={false}
      >
        <button
          type="button"
          className="btn-close ifsc-modal-btn"
          aria-label="Close"
          onClick={onHide}
        >
          <span className="icon-close"></span>
        </button>
        <Modal.Header className="modal-header ifsc-modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <span className="icon-close circle-icon"></span>
            <p className="ifsc-modal-title">Bank Verification failed!</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ifsc-modal-body">
            <p className="body-title">
              Oops! There was a problem verifying details from the bank's end. Collect cancelled cheque for verification.
            </p>
          </div>
          <button class="form-submit" type="submit" onClick={handleProceedBtn}>
            Okay
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
}


export default BankDetails;
